// Common
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_PUBS = 'SET_PUBS'
export const SET_ADS = 'SET_ADS'
export const NEXT_PAGE = 'NEXT_PAGE'
export const RESET_PAGE = 'RESET_PAGE'
export const APPEND_PUBS = 'APPEND_PUBS'
export const APPEND_ADS = 'APPEND_ADS'
export const SET_USER_AGENT = 'SET_USER_AGENT'
export const SET_DISTANCE = 'SET_DISTANCE'
export const SET_SEARCH_LOCATIONS = 'SET_SEARCH_LOCATIONS'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_SEARCH_PURCHASES_QUERY = 'SET_SEARCH_PURCHASES_QUERY'
export const SET_SEARCH_SALES_QUERY = 'SET_SEARCH_SALES_QUERY'
export const SET_IS_FETCHING  = 'SET_IS_FETCHING'
export const SET_REFRESH_HOME  = 'SET_REFRESH_HOME'
export const SET_FRONTEND_OUT_OF_DATE = 'SET_FRONTEND_OUT_OF_DATE'
export const SET_VERSION_CHECKED = 'SET_VERSION_CHECKED'
export const SET_MAINTENANCE = 'SET_MAINTENANCE'
export const SET_TEMP_LOCATIONS = 'SET_TEMP_LOCATIONS'

// Security notices
export const SET_SECURITY_NOTICE_SHOWN = 'SET_SECURITY_NOTICE_SHOWN'

// User
export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_RESET_STATE = 'USER_RESET_STATE'
export const SET_USER_TOKEN = 'SET_USER_TOKEN'
export const SET_USER_REFRESH = 'SET_USER_REFRESH'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_CHECKING_ACCOUNT = 'SET_USER_CHECKING_ACCOUNT'
export const SET_USER_FAVORITES = 'SET_USER_FAVORITES'
export const USER_SET_PUBLICATIONS = 'USER_SET_PUBLICATIONS'
export const USER_SET_PURCHASES = 'USER_SET_PURCHASES'
export const USER_SET_SALES = 'USER_SET_SALES'
export const USER_SET_AGGREGATIONS = 'USER_SET_AGGREGATIONS'
export const USER_SET_AWAITING = 'USER_SET_AWAITING'
export const USER_SET_CHECKING_ACCOUNT_MOVEMENTS = 'USER_SET_CHECKING_ACCOUNT_MOVEMENTS'
export const USER_SET_CHECKING_ACCOUNT_PAGINATION = 'USER_SET_CHECKING_ACCOUNT_PAGINATION'
export const USER_SET_FOLLOWING = 'USER_SET_FOLLOWING'
export const USER_SET_NOTIFICATIONS = 'USER_SET_NOTIFICATIONS'
export const USER_APPEND_NOTIFICATIONS = 'USER_APPEND_NOTIFICATIONS'
export const USER_NOTIFICATIONS_NEXT_PAGE = 'USER_NOTIFICATIONS_NEXT_PAGE'
export const USER_ADD_NOTIFICATION = 'USER_ADD_NOTIFICATION'
export const USER_UPDATE_NOTIFICATION = 'USER_UPDATE_NOTIFICATION'
export const USER_SET_PUBLICATION_STATUS = 'USER_SET_PUBLICATION_STATUS'
export const USER_CONVERT_TO_ADDITIONAL = 'USER_CONVERT_TO_ADDITIONAL'
export const USER_SET_PUBLICATIONS_PENDING_QUESTIONS = 'USER_SET_PUBLICATIONS_PENDING_QUESTIONS'
export const USER_SET_PUBLICATIONS_ANSWERED_QUESTIONS = 'USER_SET_PUBLICATIONS_ANSWERED_QUESTIONS'
export const USER_SET_PHONES = 'USER_SET_PHONES'
export const USER_SET_EMAILS = 'USER_SET_EMAILS'
export const USER_SET_LOCATIONS = 'USER_SET_LOCATIONS'
export const USER_SET_PAGE = 'USER_SET_PAGE'
export const USER_SET_PURCHASES_PAGE = 'USER_PURCHASES_SET_PAGE'
export const USER_SET_TOTAL_PAGES = 'USER_SET_TOTAL_PAGES'
export const USER_SET_PURCHASES_TOTAL_PAGES = 'USER_SET_PURCHASES_TOTAL_PAGES'
export const USER_SET_FOLLOWING_PAGINATION = 'USER_SET_FOLLOWING_PAGINATION'
export const USER_TOGGLE_REPUBLISH = 'USER_TOGGLE_REPUBLISH'
export const USER_SET_NOTIFICATIONS_CHECKPOINT = 'USER_SET_NOTIFICATIONS_CHECKPOINT'
export const USER_SET_NEW_UNANSWERED_QUESTION = 'USER_SET_NEW_UNANSWERED_QUESTION'
export const USER_SET_MARKETPLACE = 'USER_SET_MARKETPLACE'

// Filters
export const RESET_FILTERS_STATE = 'RESET_FILTERS_STATE'
export const SET_FILTERS_GROUP = 'SET_FILTERS_GROUP'
export const SET_FILTERS_APPLIED = 'SET_FILTERS_APPLIED'
export const ADD_SIMPLE_FILTER = 'ADD_SIMPLE_FILTER'
export const REMOVE_SIMPLE_FILTER = 'REMOVE_SIMPLE_FILTER'
export const SET_SIMPLE_FILTERS = 'SET_SIMPLE_FILTERS'
export const SET_PURCHASES_SIMPLE_FILTERS = 'SET_PURCHASES_SIMPLE_FILTERS'
export const SET_SALES_SIMPLE_FILTERS = 'SET_SALES_SIMPLE_FILTERS'
export const SET_FILTER_PRICE = 'SET_FILTER_PRICE'
export const SET_FILTER_PURCHASES_PRICE = 'SET_FILTER_PURCHASES_PRICE'
export const SET_FILTER_SALES_PRICE = 'SET_FILTER_SALES_PRICE'
export const SET_FILTERS_LOCATION = 'SET_FILTERS_LOCATION'
export const SET_FILTER_FOR_SALE = 'SET_FILTER_FOR_SALE'

// Category
export const SET_CAT_ID = 'SET_CAT_ID'
export const SET_CAT_PUBS = 'APPEND_CAT_PUBS'
export const SET_CAT_PAGE = 'SET_CAT_PAGE'
export const SET_CAT_TOTAL_PAGES = 'SET_CAT_TOTAL_PAGES'
export const SET_CAT_TOTAL_PUBS = 'SET_CAT_TOTAL_PUBS'
export const SET_CAT_ADS = 'SET_CAT_ADS'
export const SET_CAT_BREADCRUMB = 'SET_CAT_BREADCRUMB'
export const SET_CAT_MARKETABLE = 'SET_CAT_MARKETABLE'
export const SET_RESET_STATE = 'SET_RESET_STATE'

// Sell
export const RESET_SELL_INITIAL_STATE = 'RESET_SELL_INITIAL_STATE'
export const SET_SELL_CATEGORY_ID = 'SET_SELL_CATEGORY_ID'
export const SET_SELL_MLA_CATEGORY_ID = 'SET_SELL_MLA_CATEGORY_ID'
export const SET_SELL_ID = 'SET_SELL_ID'
export const SET_SELL_TITLE = 'SET_SELL_TITLE'
export const SET_SELL_BODY = 'SET_SELL_BODY'
export const ADD_SELL_LOCATION = 'ADD_SELL_LOCATION'
export const REMOVE_SELL_LOCATION = 'REMOVE_SELL_LOCATION'
export const SET_SELL_PRICE_VALUE = 'SET_SELL_PRICE_VALUE'
export const SET_SELL_PRICE_CURRENCY = 'SET_SELL_PRICE_CURRENCY'
export const SET_SELL_OTHERS = 'SET_SELL_OTHERS'
export const SET_SELL_IMAGES = 'SET_SELL_IMAGES'
export const ADD_SELL_IMAGE = 'ADD_SELL_IMAGE'
export const REMOVE_SELL_IMAGE = 'REMOVE_SELL_IMAGE'
export const UPDATE_SELL_IMAGE = 'UPDATE_SELL_IMAGE'
export const SET_SELL_FETCHED_ATTRIBUTES = 'SET_SELL_FETCHED_ATTRIBUTES'
export const UPDATE_SELL_ATTRIBUTE = 'UPDATE_SELL_ATTRIBUTE'
export const ADD_SELL_PHONE = 'ADD_SELL_PHONE'
export const UPDATE_SELL_PHONE = 'UPDATE_SELL_PHONE'
export const REMOVE_SELL_PHONE = 'REMOVE_SELL_PHONE'
export const SET_SELL_PUB_STATUS_ID = 'SET_SELL_PUB_STATUS_ID'
export const SET_SELL_PUB_STATUS = 'SET_SELL_PUB_STATUS'
export const SET_HL_VALUE = 'SET_HL_VALUE'
export const SET_PAYMENT_GATEWAY = 'SET_PAYMENT_GATEWAY'
export const SET_HL_CALC = 'SET_HL_CALC'
export const SET_HL_FINAL = 'SET_HL_FINAL'
export const SET_SELL_CATEGORY_PATH = 'SET_SELL_CATEGORY_PATH'
export const ADD_SELL_EMAIL = 'ADD_SELL_EMAIL'
export const SET_SELL_GEOPOINT = 'SET_SELL_GEOPOINT'
export const SET_SELL_LOCATIONS = 'SET_SELL_LOCATIONS'
export const SET_SELL_PHONES = 'SET_SELL_PHONES'
export const SET_SELL_EMAILS = 'SET_SELL_EMAILS'
export const SET_SELL_HL_REQUESTED = 'SET_SELL_HL_REQUESTED'
export const SET_SELL_CHECK_REQUIRED_FIELDS = 'SET_SELL_CHECK_REQUIRED_FIELDS'
export const SET_SELL_FIELDS_FILLED = 'SET_SELL_FIELDS_FILLED'
export const ADD_SELL_ATTR_WITH_ERRORS = 'ADD_SELL_ATTR_WITH_ERRORS'
export const REMOVE_SELL_ATTR_WITH_ERRORS = 'REMOVE_SELL_ATTR_WITH_ERRORS'
export const SET_SELL_FOR_SALE = 'SET_SELL_FOR_SALE'
export const SET_SELL_STOCK = 'SET_SELL_STOCK'
export const SET_SELL_SHIPPING_TYPE = 'SET_SELL_SHIPPING_TYPE'
export const SET_SELL_LIMIT_ON_CATEGORY = 'SET_SELL_LIMIT_ON_CATEGORY'
export const SET_SELL_REMAINING_PUBS = 'SET_SELL_REMAINING_PUBS'
export const SET_SELL_HIGHLIGHT_PENDING = 'SET_SELL_HIGHLIGHT_PENDING'
export const SET_SELL_CATALOG_DOMAIN = 'SET_SELL_CATALOG_DOMAIN'
export const SET_SELL_ATTRIBUTE_SUGGESTIONS = 'SET_SELL_ATTRIBUTE_SUGGESTIONS'
export const ADD_SELL_ATTRIBUTE_SUGGESTIONS = 'ADD_SELL_ATTRIBUTE_SUGGESTIONS'
export const REMOVE_SELL_ATTRIBUTE_SUGGESTIONS = 'REMOVE_SELL_ATTRIBUTE_SUGGESTIONS'
export const SET_SELL_API_ERROR = 'SET_SELL_API_ERROR'
export const SET_SELL_IS_FETCHING = 'SET_SELL_IS_FETCHING'
// export const APPEND_IMAGES = 'APPEND_IMAGES'
export const PUB_RESET_STATE = 'PUB_RESET_STATE'
export const PUB_SET_TITLE = 'PUB_SET_TITLE'
export const PUB_SET_BODY = 'PUB_SET_BODY'
export const PUB_SET_ID = 'PUB_SET_ID'
export const PUB_SET_CATEGORY_ID = 'PUB_SET_CATEGORY_ID'
export const PUB_SET_CURRENCY_CODE = 'PUB_SET_CURRENCY_CODE'
export const PUB_SET_CURRENCY_VALUE = 'PUB_SET_CURRENCY_VALUE'
export const PUB_SET_STATUS = 'PUB_SET_STATUS'
export const PUB_SET_TYPE = 'PUB_SET_TYPE'
export const PUB_SET_DATE = 'PUB_SET_DATE'
export const PUB_SET_USER_ID = 'PUB_SET_USER_ID'
export const PUB_SET_ENABLE_QUESTIONS = 'PUB_SET_ENABLE_QUESTIONS'
export const PUB_SET_MEDIA = 'PUB_SET_MEDIA'
export const PUB_SET_PHONES = 'PUB_SET_PHONES'
export const PUB_SET_GEOPOINT = 'PUB_SET_GEOPOINT'
export const PUB_SET_LOCATIONS = 'PUB_SET_LOCATIONS'
export const PUB_SET_EMAILS = 'PUB_SET_EMAILS'
export const PUB_SET_ATTRIBUTES = 'PUB_SET_ATTRIBUTES'
export const PUB_SET_CATEGORY_PATH = 'PUB_SET_CATEGORY_PATH'
export const PUB_SET_USER = 'PUB_SET_USER'
export const PUB_SET_VIEWS = 'PUB_SET_VIEWS'
export const PUB_SET_HIGHLIGHT = 'PUB_SET_HIGHLIGHT'
export const PUB_SET_QUESTIONS = 'PUB_SET_QUESTIONS'
export const PUB_ADD_QUESTIONS = 'PUB_ADD_QUESTIONS'
export const PUB_SET_QUESTIONS_PAGINATION = 'PUB_SET_QUESTIONS_PAGINATION'
export const PUB_SET_RELATED_PUBS = 'PUB_SET_RELATED_PUBS'
export const PUB_SET_ADS = 'PUB_SET_ADS'
export const PUB_SET_FAVORITE = 'PUB_SET_FAVORITE'
export const PUB_SET_FOR_SALE = 'PUB_SET_FOR_SALE'
export const PUB_SET_SALABLE = 'PUB_SET_SALABLE'
export const PUB_SET_SHIPPING_TYPE = 'PUB_SET_SHIPPING_TYPE'
export const PUB_SET_PRODUCT = 'PUB_SET_PRODUCT'

// Profile
export const PROFILE_SET_PUBLICATIONS = 'PROFILE_SET_PUBLICATIONS'
export const PROFILE_SET_INFO = 'PROFILE_SET_INFO'
export const PROFILE_SET_AGGREGATIONS = 'PROFILE_SET_AGGREGATIONS'
export const PROFILE_RESET_STATE = 'PROFILE_RESET_STATE'
export const PROFILE_SET_FOLLOW_STATUS = 'PROFILE_SET_FOLLOW_STATUS'
export const PROFILE_SET_FOLLOWERS = 'PROFILE_SET_FOLLOWERS'
export const PROFILE_SET_FOLLOWING = 'PROFILE_SET_FOLLOWING'
export const PROFILE_SET_PAGE = 'PROFILE_SET_PAGE'
export const PROFILE_SET_TOTAL_PAGES = 'PROFILE_SET_TOTAL_PAGES'
export const PROFILE_SET_TOTAL_PUBS = 'PROFILE_SET_TOTAL_PUBS'

// Favorites
export const FAV_RESET_STATE = 'FAV_RESET_STATE'
export const FAV_SET_PUBLICATIONS = 'FAV_SET_PUBLICATIONS'
export const FAV_SET_AGGREGATIONS = 'FAV_SET_AGGREGATIONS'
export const FAV_SET_PAGE = 'FAV_SET_PAGE'
export const FAV_SET_TOTAL_PAGES = 'FAV_SET_TOTAL_PAGES'
export const FAV_SET_TOTAL_PUBS = 'FAV_SET_TOTAL_PUBS'

// Buy
export const BUY_SET_QUANTITY = 'BUY_SET_QUANTITY'
export const BUY_SET_PRICE_BUY_UNIT = 'BUY_SET_PRICE_BUY_UNIT'
export const BUY_SET_TOTAL_TO_PAY = 'BUY_SET_TOTAL_TO_PAY'
export const BUY_SET_PUBLICATION_ID = 'BUY_SET_PUBLICATION_ID'
export const BUY_DELIVERY_SET_STREET = 'BUY_DELIVERY_SET_STREET'
export const BUY_DELIVERY_SET_NUMBER = 'BUY_DELIVERY_SET_NUMBER'
export const BUY_DELIVERY_SET_LEVEL = 'BUY_DELIVERY_SET_LEVEL'
export const BUY_DELIVERY_SET_DEPARTMENT = 'BUY_DELIVERY_SET_DEPARTMENT'
export const BUY_DELIVERY_SET_ZIP_CODE = 'BUY_DELIVERY_SET_ZIP_CODE'
export const BUY_DELIVERY_SET_LOCATION = 'BUY_DELIVERY_SET_LOCATION'
export const BUY_DELIVERY_SET_PROVINCE = 'BUY_DELIVERY_SET_PROVINCE'
export const BUY_DELIVERY_SET_STRING = 'BUY_DELIVERY_SET_STRING'
export const BUY_DELIVERY_SET_CITY = 'BUY_DELIVERY_SET_CITY'
export const BUY_DELIVERY_SET_DESCRIPTION = 'BUY_DELIVERY_SET_DESCRIPTION'
export const BUY_DELIVERY_SET_RECIPIENT_NAME = 'BUY_DELIVERY_SET_RECIPIENT_NAME'
export const BUY_DELIVERY_SET_RECIPIENT_PHONE = 'BUY_DELIVERY_SET_RECIPIENT_PHONE'
export const BUY_ORDER_SET_CURRENCY_CODE = 'BUY_ORDER_SET_CURRENCY_CODE'
export const BUY_ORDER_SET_DISCOUNT = 'BUY_ORDER_SET_DISCOUNT'
export const BUY_ORDER_SET_FINAL_PRICE_AMOUNT = 'BUY_ORDER_SET_FINAL_PRICE_AMOUNT'
export const BUY_ORDER_SET_ID = 'BUY_ORDER_SET_ID'
export const BUY_ORDER_SET_INIT_POINT = 'BUY_ORDER_SET_INIT_POINT'
export const BUY_ORDER_SET_PAYMENT_GATEWAY = 'BUY_ORDER_SET_PAYMENT_GATEWAY'
export const BUY_ORDER_SET_PREFERENCE_ID = 'BUY_ORDER_SET_PREFERENCE_ID'
export const BUY_ORDER_SET_SANDBOX_INIT_POINT = 'BUY_ORDER_SET_SANDBOX_INIT_POINT'
export const BUY_ORDER_SET_TOTAL_PRICE_AMOUNT = 'BUY_ORDER_SET_TOTAL_PRICE_AMOUNT'
export const BUY_ORDER_SET_PUBLICATION_ID = 'BUY_ORDER_SET_PUBLICATION_ID'

// Purchase
export const PURCHASE_RESET_STATE = 'PURCHASE_RESET_STATE'
export const BUY_PURCHASE_SET_ID = 'BUY_PURCHASE_SET_ID'
export const BUY_PURCHASE_SET_MERCHANT_ORDER_ID = 'BUY_PURCHASE_SET_MERCHANT_ORDER_ID'
export const BUY_PURCHASE_SET_TITLE = 'BUY_PURCHASE_SET_TITLE'
export const BUY_PURCHASE_SET_TOTAL_AMOUNT = 'BUY_PURCHASE_SET_TOTAL_AMOUNT'
export const BUY_PURCHASE_SET_ORDER_STATUS = 'BUY_PURCHASE_SET_ORDER_STATUS'
export const BUY_PURCHASE_SET_PAYMENT_STATUS = 'BUY_PURCHASE_SET_PAYMENT_STATUS'
export const BUY_PURCHASE_SET_INSTALLMENTS = 'BUY_PURCHASE_SET_INSTALLMENTS'
export const BUY_PURCHASE_SET_PAYMENT_DATE = 'BUY_PURCHASE_SET_PAYMENT_DATE'

export const BUY_SELLER_SET_FANTASY_NAME = 'BUY_SELLER_SET_FANTASY_NAME'
export const BUY_SELLER_SET_PHONE = 'BUY_SELLER_SET_PHONE'
export const BUY_SELLER_SET_ADDRESS = 'BUY_SELLER_SET_ADDRESS'
export const BUY_SELLER_SET_EMAIL = 'BUY_SELLER_SET_EMAIL'

// Sale
export const SALE_RESET_STATE = 'SALE_RESET_STATE'
export const SALE_ORDER_SET_ID = 'SALE_ORDER_SET_ID'
export const SALE_ORDER_SET_MERCHANT_ORDER_ID = 'SALE_ORDER_SET_MERCHANT_ORDER_ID'
export const SALE_ORDER_SET_TITLE = 'SALE_ORDER_SET_TITLE'
export const SALE_ORDER_SET_PUBLICATION_ID = 'SALE_ORDER_SET_PUBLICATION_ID'
export const SALE_ORDER_SET_TOTAL_AMOUNT = 'SALE_ORDER_SET_TOTAL_AMOUNT'
export const SALE_ORDER_SET_PAYMENT_STATUS = 'SALE_ORDER_SET_PAYMENT_STATUS'
export const SALE_ORDER_SET_INSTALLMENTS = 'SALE_ORDER_SET_INSTALLMENTS'
export const SALE_ORDER_SET_PAYMENT_DATE = 'SALE_ORDER_SET_PAYMENT_DATE'
export const SALE_ORDER_SET_PAYMENT_ID = 'SALE_ORDER_SET_PAYMENT_ID'

export const SALE_SHIPPING_SET_STREET = 'SALE_SHIPPING_SET_STREET'
export const SALE_SHIPPING_SET_NUMBER = 'SALE_SHIPPING_SET_NUMBER'
export const SALE_SHIPPING_SET_FLOOR = 'SALE_SHIPPING_SET_FLOOR'
export const SALE_SHIPPING_SET_DEPARTMENT = 'SALE_SHIPPING_SET_DEPARTMENT'
export const SALE_SHIPPING_SET_LOCATION = 'SALE_SHIPPING_SET_LOCATION'
export const SALE_SHIPPING_SET_PROVINCE = 'SALE_SHIPPING_SET_PROVINCE'
export const SALE_SHIPPING_SET_STRING = 'SALE_SHIPPING_SET_STRING'
export const SALE_SHIPPING_SET_CITY = 'SALE_SHIPPING_SET_CITY'
export const SALE_SHIPPING_SET_DESCRIPTION = 'SALE_SHIPPING_SET_DESCRIPTION'
export const SALE_SHIPPING_SET_RECIPIENT_NAME = 'SALE_SHIPPING_SET_RECIPIENT_NAME'
export const SALE_SHIPPING_SET_RECIPIENT_PHONE = 'SALE_SHIPPING_SET_RECIPIENT_PHONE'

export const SALE_BUYER_SET_NAME = 'SALE_BUYER_SET_NAME'
export const SALE_BUYER_SET_PHONES = 'SALE_BUYER_SET_PHONES'
export const SALE_BUYER_SET_ADDRESS = 'SALE_BUYER_SET_ADDRESS'
export const SALE_BUYER_SET_EMAIL = 'SALE_BUYER_SET_EMAIL'
export const SALE_BUYER_SET_ID = 'SALE_BUYER_SET_ID'

export const SALE_SELLER_SET_NAME = 'SALE_SELLER_SET_NAME'
export const SALE_SELLER_SET_PHONES = 'SALE_SELLER_SET_PHONES'
export const SALE_SELLER_SET_ADDRESS = 'SALE_SELLER_SET_ADDRESS'
export const SALE_SELLER_SET_EMAIL = 'SALE_SELLER_SET_EMAIL'
export const SALE_SELLER_SET_ID = 'SALE_SELLER_SET_ID'

// Sales list
export const SALES_LIST_SET_SALES = 'SALES_LIST_SET_SALES'
export const SALES_LIST_SET_PAGE = 'SALES_LIST_SET_PAGE'
export const SALES_LIST_SET_TOTAL_PAGES = 'SALES_LIST_SET_TOTAL_PAGES'
export const SALES_LIST_SET_TOTAL_SALES = 'SALES_LIST_SET_TOTAL_SALES'
export const SALES_LIST_SET_AGGREGATIONS = 'SALES_LIST_SET_AGGREGATIONS'

// Purchases list
export const PURCHASES_LIST_SET_PURCHASES = 'PURCHASES_LIST_SET_PURCHASES'
export const PURCHASES_LIST_SET_PAGE = 'PURCHASES_LIST_SET_PAGE'
export const PURCHASES_LIST_SET_TOTAL_PAGES = 'PURCHASES_LIST_SET_TOTAL_PAGES'
export const PURCHASES_LIST_SET_TOTAL_PURCHASES = 'PURCHASES_LIST_SET_TOTAL_PURCHASES'
export const PURCHASES_LIST_SET_AGGREGATIONS = 'PURCHASES_LIST_SET_AGGREGATIONS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js